'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setLoading = exports.setAvailable = exports.isLoading = exports.isAvailable = exports.hasLoadingExpired = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.reducer = reducer;

var _deep = require('helpers/deep');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_VENDOR_STATUS = 'classpass/vendor/SET_VENDOR_STATUS'; /* eslint-disable no-use-before-define */

var STATUS = {
  AVAILABLE: 'available',
  LOADING: 'loading',
  PRELOADING: 'preloading'
};

var TRANSITIONS = [[STATUS.LOADING, STATUS.AVAILABLE], [STATUS.PRELOADING, STATUS.AVAILABLE], [STATUS.PRELOADING, STATUS.LOADING]];

function canTransition(state, status, vendor) {
  var vendorStatus = selectStatus(state, vendor);
  return !!TRANSITIONS.find(function (_ref) {
    var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
        from = _ref2[0],
        to = _ref2[1];

    return vendorStatus === from && status === to;
  });
}

function hasExpired(state, status, vendor) {
  var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var now = Date.now();
  return isStatus(state, status, vendor) && now - (0, _deep.deepExtract)(vendor + '.timestamp', state, now) > duration;
}

function isStatus(state, status, vendor) {
  return selectStatus(state, vendor) === status;
}

function selectStatus(state, vendor) {
  return (0, _deep.deepExtract)(vendor + '.status', state, STATUS.PRELOADING);
}

function setStatus(status, vendor) {
  return { type: SET_VENDOR_STATUS, vendor: vendor, status: status };
}

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var status = action.status,
      type = action.type,
      vendor = action.vendor;

  switch (type) {
    case SET_VENDOR_STATUS:
      return canTransition(state, status, vendor) ? (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, vendor, { status: status, timestamp: Date.now() })) : state;
    default:
      return state;
  }
}

var withVendorState = function withVendorState(func) {
  for (var _len = arguments.length, bindArgs = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    bindArgs[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return func.apply(undefined, [state.vendor].concat(bindArgs, args));
  };
};

var hasLoadingExpired = exports.hasLoadingExpired = withVendorState(hasExpired, STATUS.LOADING);
var isAvailable = exports.isAvailable = withVendorState(isStatus, STATUS.AVAILABLE);
var isLoading = exports.isLoading = withVendorState(isStatus, STATUS.LOADING);
var setAvailable = exports.setAvailable = setStatus.bind(null, STATUS.AVAILABLE);
var setLoading = exports.setLoading = setStatus.bind(null, STATUS.LOADING);